<template>
  <div class="container">
  <div class="pageContent">
    <main v-html="params.text" :class="params.menu.length<=0?'noMenu':''"></main>
    <aside v-if="params.menu.length>0">
      <tab-menu :items="params.menu"/>
    </aside>
  </div>
  </div>
</template>

<script>
export default {
  name: "AboutPages",
  props: {
    params: {
      type: Object,
      default: {},
    }
  }
}
</script>

<style lang="scss" scoped>
.pageContent {
  display: flex;
  width: 100%;
  margin-top: 80px;
  justify-content: space-between;
  @include tablet {
    width: 100%;
    margin-top: 50px;
    flex-wrap: wrap-reverse;
  }
  main {
    width: 70%;
    &.noMenu {
      width: 100%;
    }
    @include tablet {
      width: 100%;
    }
  }
  aside {
    width: 26%;
    @include tablet {
      width: 100%;
      margin-bottom: 50px;
    }
  }

}
</style>